export class AppsFlyerLinks {
  static DPAYMENT_COMPLETE: string = 'https://ikasa.onelink.me/IdAp/0r1fdugn';
  static DPAYMENT_CANCEL: string = 'https://ikasa.onelink.me/IdAp/4xssjao4';

  static AU_PAYMENT_COMPLETE: string = 'https://ikasa.onelink.me/IdAp/dcyydkk7';
  static AU_PAYMENT_CANCEL: string = 'https://ikasa.onelink.me/IdAp/3uk715hk';

  static SOFTBANK_PAYMENT_COMPLETE: string = 'https://ikasa.onelink.me/IdAp/masl10aq';
  static SOFTBANK_PAYMENT_CANCEL: string = 'https://ikasa.onelink.me/IdAp/lzc9nv3k';

  static CREDIT_PAYMENT_COMPLETE: string = 'https://ikasa.onelink.me/IdAp/adydoq0n';
  static CREDIT_PAYMENT_CANCEL: string = 'https://ikasa.onelink.me/IdAp/s5s6uhrp';
}